export default () => {
  window.__APPS__ = window.__APPS__ || {};
  window.__APPS__.rating = {
    version: SENTRY_RELEASE, // eslint-disable-line
  };
};
